import router from "@/router";
import store from "@/store";
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api";
import useFlatPickr from "@/utils/hooks/useFlatPickr";

export default function useCodeTemplateModal() {
  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr();

  const formModal = reactive({
    templateSelect: "",
  });

  const setTemplate = () => {
    router
      .push({
        path: `/privilege/code-template/create?templateType=${formModal.templateSelect}`,
      })
      .catch(() => {});
  };


  return {
    formModal,
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,

    setTemplate,
  };
}
